import styled, { css } from "styled-components";

interface IContainer {
  active?: boolean;
  disabled?: boolean;
  isupdate?: boolean;
}

export const Container = styled.div<IContainer>`
  position: relative;
  height: 38px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  overflow: hidden;
  
  .editor {

    .ProseMirror {
      height: 38px;
      padding: 8px 8px 8px 12px;
      border-radius: 6px;
      background-color: ${({ theme }) => theme.colors.surface.surface};
      border: none !important;
      outline: none !important;
      overflow: hidden;
      cursor: pointer;
      
      p {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 8px;
    height: 32px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 8px;

    .footerLeft {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;

      .iconSmile {
        width: 24px !important;
        height: 24px !important;
        border-radius: 6px !important;
        padding: 6px;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
        cursor: pointer;
  
       &:hover {
          background-color: ${({ theme }) => theme.colors.surface.surfaceOutline} !important;
        }
      }

      .iconPaperclip {
        width: 24px !important;
        height: 24px !important;
        border-radius: 6px !important;
        margin-top: 2px;
        padding: 6px;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
        cursor: pointer;
  
       &:hover {
          background-color: ${({ theme }) => theme.colors.surface.surfaceOutline} !important;
        }
      }
    }

    .footerRight {
      display: flex;
      flex-direction: row;
      align-items: center;

      .btnCancel {
        height: 32px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .btnSubmit {
        height: 32px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 4px;
      }
    }
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  ${({ active, theme }) => active && css`
    height: auto;

    .editor {
      .ProseMirror {
        height: auto;
        min-height: 38px;
        max-height: 120px;
        margin-bottom: 52px !important;
        overflow-y: scroll;
        cursor: default;
      }
    }
    
    &:hover {
      background-color: ${theme.colors.surface.surface};
    }
  `}

  ${({ disabled }) => disabled && css`

    .input {
      background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
      cursor: not-allowed;

      &:hover {
        background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
      }
    }
    
    &:hover {
      background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
    }
  `}

  ${({ isupdate }) => isupdate && css`
    border: none;
    
    .input {
      padding: 0;
    }

    .footer {
      padding-left: 0;
      padding-right: 0;
    }
  `}
`;
